"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const reactstrap_1 = require("reactstrap");
const _1 = require("./../");
exports.PageHeader = (_a) => {
    var { children, hideBackButton, title, onClickBackButton } = _a, otherProps = __rest(_a, ["children", "hideBackButton", "title", "onClickBackButton"]);
    return (React.createElement("header", Object.assign({ className: "page-comp-header" }, otherProps),
        React.createElement(reactstrap_1.Row, null,
            React.createElement(reactstrap_1.Col, null,
                React.createElement("div", { className: "page-comp-header-left" },
                    !hideBackButton && (React.createElement("button", { className: "btn btn-link btn-icon btn-square", title: "Go back", onClick: onClickBackButton },
                        React.createElement(_1.Icon, { name: "arrow_back" }))),
                    React.createElement("h1", { className: "page-comp-title" }, title))),
            React.createElement(reactstrap_1.Col, null,
                React.createElement("div", { className: "page-comp-header-right" }, children)))));
};
exports.PageHeader.displayName = 'PageHeader';
exports.PageHeader.defaultProps = {
    hideBackButton: false,
    onClickBackButton: () => { return; },
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageHeader.tsx
// module id = 364
// module chunks = 0